<template>
  <div class="layout">
    <LayoutHead v-if="!$route.meta.hideHeader" />
    <LayoutBanner v-if="$route.meta.showBanner" />
    <LayoutBreadcrumb v-if="!$route.meta.hideBreadcrumb" />
    <LayoutMain />
    <LayoutFooter v-if="!$route.meta.hideFooter" />
    <LayoutToolbar v-if="!$route.meta.hideHeader" />
  </div>
</template>

<script>
import LayoutHead from "./components/LayoutHead/index.vue";
import LayoutFooter from "./components/LayoutFooter/index.vue";
import LayoutMain from "./components/LayoutMain.vue";
import LayoutBreadcrumb from "./components/LayoutBreadcrumb.vue";
import LayoutToolbar from "./components/LayoutToolbar.vue";
import LayoutBanner from "./components/LayoutBanner.vue";

export default {
  name: "Layout",
  components: {
    LayoutBreadcrumb,
    LayoutHead,
    LayoutFooter,
    LayoutMain,
    LayoutToolbar,
    LayoutBanner,
  },

  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.layout {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
}
</style>
